import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { getJWTToken } from '@sonar-software/sonar-ts-lib';
import { reducers } from './reducers';
import { watchers } from './watchers';
import { clearAuth, updateAuth } from './application/auth/actions';
import { configureStore } from '@reduxjs/toolkit';
const loggerMiddleware = createLogger({
    collapsed: true,
    predicate: () => localStorage.getItem('enableLogging') === 'true'
});
const authMiddleware = (store) => (next) => (action) => {
    const result = next(action);
    const currentAuthToken = store.getState().application.auth.token;
    const storageAuthToken = getJWTToken();
    if (!storageAuthToken && currentAuthToken) {
        store.dispatch(clearAuth());
    }
    if (storageAuthToken && storageAuthToken !== currentAuthToken) {
        store.dispatch(updateAuth(storageAuthToken));
    }
    return result;
};
const sagaMiddleware = createSagaMiddleware();
export const store = configureStore({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: ['updateCoreInitiativesIdMap']
        }
    })
        .concat(sagaMiddleware)
        .concat(authMiddleware)
        .concat(loggerMiddleware),
    reducer: reducers
});
sagaMiddleware.run(watchers);
